import { queryOptions } from "@tanstack/react-query";

import * as authApi from "./api";

export const authQueryKeys = {
  userInfo: ["auth", "user-info"] as const,
} as const;

export function getUserInfoQueryOptions() {
  return queryOptions({
    queryKey: authQueryKeys.userInfo,
    queryFn: () => authApi.getUserInfo(),
  });
}
